import React from 'react';
import { Button, ButtonProps, SxProps, Theme } from '@mui/material';

import {
  primaryActionButtonSx,
  readableDisabledButtonSx,
  selectedActionButtonSx,
} from '../../utils/actionButtonStyles';

type ActionButtonVariant = 'default' | 'active';

type ActionButtonProps = ButtonProps & {
  actionVariant?: ActionButtonVariant;
  allowWrap?: boolean;
  href?: string;
  target?: string;
  rel?: string;
  to?: string;
  component?: React.ElementType;
};

const disabledActionButtonSx = {
  ...readableDisabledButtonSx,
  '&.Mui-disabled': {
    ...readableDisabledButtonSx['&.Mui-disabled'],
    opacity: 1,
    bgcolor: '#000000',
    color: 'rgba(230, 237, 243, 0.48)',
    borderColor: 'rgba(230, 237, 243, 0.28)',
    boxShadow: 'none',
  },
};

export default function ActionButton({
  actionVariant = 'default',
  allowWrap = false,
  disabled,
  variant: _variant,
  color: _color,
  sx,
  children,
  ...props
}: ActionButtonProps) {
  const variantSx = actionVariant === 'active' ? selectedActionButtonSx : primaryActionButtonSx;
  const mergedSx: SxProps<Theme> = [
    ...(Array.isArray(sx) ? sx : sx ? [sx] : []),
    {
      whiteSpace: allowWrap ? 'normal' : 'nowrap',
      fontSize: '0.95rem',
      lineHeight: 1.2,
      '& .MuiButton-startIcon': {
        mr: 1,
      },
      '& .MuiButton-endIcon': {
        ml: 1,
      },
    },
    variantSx,
    disabled ? disabledActionButtonSx : {},
  ];

  return (
    <Button
      variant="contained"
      color="primary"
      disabled={disabled}
      data-action-button="true"
      data-action-variant={disabled ? 'disabled' : actionVariant}
      sx={mergedSx}
      {...props}
    >
      {children}
    </Button>
  );
}
